/**
 * Enum print notify type
 * @readonly
 * @enum {String} PrintNotifyTypeEnum
 */

const PrintNotifyTypeEnum = {
  ORDER                     : 'ORDER',
  PREPARATION               : 'PREPARATION',
  RECEIPT                   : 'RECEIPT',
  RECEIPT_CREDIT            : 'RECEIPT_CREDIT',
  FNB                       : 'FNB',
  FNB_CANCEL                : 'FNB_CANCEL',
  FNB_RETURN                : 'FNB_RETURN',
  UNKNOWN                   : 'UNKNOWN',
  TABLE_ORDER_ITEMS_CANCELED: 'TABLE_ORDER_ITEMS_CANCELED'
}

export default PrintNotifyTypeEnum
